import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const RuleSetStatusBadge = ({ status, className, }) => {
    let badge = { color: "secondary", text: "No" };
    badge = status ? { color: "success", text: "Yes" } : badge;
    return (_jsx("span", { className: `badge badge-${badge.color} ${className || ""}`, children: badge.text }));
};
export default RuleSetStatusBadge;
